// Native
import { useState } from "react"

// Components
import { Badge, ButtonGroup, Td, Tr } from "@chakra-ui/react"
import { Dash, IconButton, Section, Table, Tag } from "components"

// Config
import { Moment } from "config"

// Hooks
import { useConsultantCycleHistory } from "hooks"
import { Mask } from "config"

export default function History({ data:consultant, ...props }){

    const [ page, setPage ] = useState(1)
    const history = useConsultantCycleHistory(consultant.data?.id, page)

    const columns = [
        { children: '', isNumeric: true }, 
        { children: '', isNumeric: true }, 
        { children: 'Início', isNumeric: true }, 
        { children: 'Fim', isNumeric: true }
    ]

    return(
    <>
        <Section title="Histórico de Ciclos do Consultor">
            <ButtonGroup size="xs">
                <IconButton icon="refresh" isLoading={history.isFetching} onClick={history.refetch} />
            </ButtonGroup>
        </Section>
        
        <Table columns={columns} setPage={setPage} meta={history.data?.meta} loading={history.isLoading}>
            { history.data?.data?.map(item => <Item data={item} />) }
        </Table>
    </>
    )
}

const Item = ({ data:item, ...props }) => (
    <Tr {...props}>
        <Td isNumeric>{!item.ended ? <Tag size="sm" colorScheme="teal" children="Ciclo atual" /> : <Tag size="sm" children="Ciclo fechado" /> }</Td>
        <Td w="30px">{item.became_diamond && <Tag variant="solid" colorScheme="purple" icon="diamond" label="Se tornou diamante durante o ciclo" />}</Td>
        <Td isNumeric fontSize="xs" children={Moment(item.started).format('LL')} />
        <Td isNumeric fontSize="xs" children={<Dash children={item.ended && Moment(item.ended).format('LL')} />}></Td>
    </Tr>
)